import React, { ComponentPropsWithoutRef, FC } from 'react'
import { Button, ScriptValueDialog } from '@microservices/wiskey-react-components'
import { Code as CodeIcon } from '@mui/icons-material'
import { Box, FormHelperText, Grid, Typography } from '@mui/material'

type ScriptValueDialogProps = Pick<
  ComponentPropsWithoutRef<typeof ScriptValueDialog>,
  'variables' | 'fieldsInfo' | 'examples' | 'language'
>

type Props = {
  scriptValue: string
  isShowScriptDialog: boolean
  onOpenScriptDialog: () => void
  onCloseScriptDialog: () => void
  onSaveScript: (script: string) => void
  errorText?: string
} & ScriptValueDialogProps

export const JavaScriptField: FC<Props> = props => {
  const {
    scriptValue,
    onCloseScriptDialog: handleCloseScriptDialog,
    isShowScriptDialog,
    onOpenScriptDialog: handleOpenScriptDialog,
    onSaveScript: handleSaveScript,
    variables,
    fieldsInfo,
    examples,
    language,
    errorText,
  } = props

  const hasError = Boolean(errorText?.trim())

  return (
    <Grid item display={'flex'} flexDirection={'column'} gap={1} mb={1} xs={12}>
      <Button
        fullWidth
        color={hasError ? 'error' : undefined}
        startIcon={<CodeIcon />}
        variant='outlined'
        onClick={handleOpenScriptDialog}
      >
        {scriptValue
          ? `Edit ${language === 'js' ? 'JavaScript' : 'JSX'} Expression`
          : `Add ${language === 'js' ? 'JavaScript' : 'JSX'} Expression`}
      </Button>
      {hasError && (
        <FormHelperText error sx={{ mx: 0 }}>
          {errorText}
        </FormHelperText>
      )}
      {scriptValue && (
        <Box p={1} sx={{ backgroundColor: '#f5f5f5', borderRadius: 1 }}>
          <Typography
            component='pre'
            variant='caption'
            sx={{
              fontFamily: 'monospace',
              fontSize: 11,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              margin: 0,
            }}
          >
            {scriptValue?.length > 100 ? scriptValue.substring(0, 100) + '...' : scriptValue}
          </Typography>
        </Box>
      )}
      {isShowScriptDialog && (
        <ScriptValueDialog
          examples={examples}
          fieldsInfo={fieldsInfo}
          isShow={isShowScriptDialog}
          language={language}
          value={scriptValue}
          variables={variables}
          onClose={handleCloseScriptDialog}
          onSave={handleSaveScript}
        />
      )}
    </Grid>
  )
}
